__turbopack_context__.v({
  "className": "FHRA0G_className",
  "variable": "FHRA0G_variable",
});
